
































































import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Checkbox from "@/shared/components/ui/Checkbox.vue";

@Component({
  components: {
    Button,
    Checkbox
  }
})
export default class TrusteeToTrusteeTransferCustodian extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  get custodianOptions () {
    return this.balanceTransferStore.custodians.map(c => ({
      value: c.custodianKey,
      text: c.name
    }));
  }

  get custodianValidation () {
    return this.balanceTransferStore.isCustodianUnknown ? "" : "required";
  }

  created () {
    this.balanceTransferStore.loadCustodians();
  }

  onCustodianChanged () {
    if (!this.balanceTransferStore.transferBalanceOptionSelected) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = true;
    }
  }

  onUnknownCustodianChanged () {
    this.balanceTransferStore.isCustodianUnknown = !this.balanceTransferStore.isCustodianUnknown;

    if (!this.balanceTransferStore.isCustodianUnknown && !this.balanceTransferStore.transferBalanceOptionSelected) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = true;
    }
  }

  goBack () {
    this.balanceTransferStore.goToStart();
  }

  onSubmit () {
    this.$validator.validate()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.balanceTransferStore.goToStep("trustee-details");
        });
  }
}
